import api from "@/api.js";

export default {
  state: {
    clients: [],
    clientsLoading: false
  },
  mutations: {
    setClients(state, payload) {
      state.clients = payload;
    },
    setClientsLoading(state, payload) {
      state.clientsLoading = payload;
    }
  },
  actions: {
    async loadClients({ commit }) {
      commit("setClientsLoading", true);
      let clients = await api.get("clients");
      commit("setClients", clients.data);
      commit("setClientsLoading", false);
    },
    async saveClient({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`clients`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadClients");
      return returnData;
    },
    async newClient({ dispatch }, payload) {
      let returnData = {};
      await api
        .post(`clients`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadClients");
      return returnData;
    }
  },
  getters: {
    clients(state) {
      return state.clients;
    },
    clientsLoading(state) {
      return state.clientsLoading;
    }
  }
};
